import { getInterventionDefinitionValidationSchema } from '~/libraries/interventions/definition/validation';

import { getInterventionDefinitionInitialValues } from '~/libraries/interventions/definition/values';
import type { NewPredefinedInterventionState } from '../reducer/wizardReducer';
import { InterventionCard } from '../../interventions/InterventionCard';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';
import { InterventionDefinitionFormBody } from '~/libraries/interventions/definition/InterventionDefinitionFormBody';
import { Form } from '~/shared/forms/Form';

export function NewPredefinedInterventionForm({
	intervention,
	readOnly = false
}: {
	intervention: NewPredefinedInterventionState;
	readOnly?: boolean;
}) {
	if (intervention.interventionDefinition.hasDefinitionFields && !intervention.fullInterventionDefinition) {
		throw new Error('Full intervention definition not found');
	}

	const { certificationPeriod, defaultAssignedDisciplineId } = useGoalsAndInterventionsWizard();

	const interventionDefinition = intervention.fullInterventionDefinition
		? intervention.fullInterventionDefinition
		: intervention.interventionDefinition;

	const initialValues = getInterventionDefinitionInitialValues(
		interventionDefinition,
		defaultAssignedDisciplineId ? [defaultAssignedDisciplineId] : [],
		certificationPeriod.endDate
	);

	const validationSchema = getInterventionDefinitionValidationSchema(interventionDefinition, certificationPeriod.endDate);
	return (
		<InterventionCard interventionDefinition={interventionDefinition}>
			<div className="flex-1">
				<Form initialValues={initialValues} validationSchema={validationSchema} readOnly={readOnly} registryId={intervention.id}>
					<InterventionDefinitionFormBody interventionDefinition={interventionDefinition} />
				</Form>
			</div>
		</InterventionCard>
	);
}
